import { inject, provideAppInitializer } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { MaintenanceService } from '../../pages/maintenance/maintenance.service'
import { DomainService } from '../services/domain.service'

export async function runMaintenanceCheck(maintenanceService: MaintenanceService, domain: string) {
	try {
		const response = await firstValueFrom(maintenanceService.fetchMaintenanceStatus(domain))
		if (response.status === 'ok' && response.result && response.result.length > 0) {
			const result = response.result[0]
			if (result?.ISONMAINTENANCE) {
				maintenanceService.redirectToMaintenance()
			}
		}
	} catch (error) {
		console.error('Error fetching maintenance mode status:', error)
	}
}

export function initializeMaintenance(): () => Promise<void> {
	const maintenanceService = inject(MaintenanceService)
	const domainService = inject(DomainService)
	return () => runMaintenanceCheck(maintenanceService, domainService.domain)
}

export const provideMaintenance = () =>
	provideAppInitializer(() => {
		const initializerFn = initializeMaintenance()
		return initializerFn()
	})
